export default __webpack_public_path__ + "static/media/user_settings.8f5065fb.svg";